enum SubmitResponseType {
  Error = 'Error',
  FormValidationError = 'FormValidationError',
  ExternalHpaRedirectResponse = 'ExternalHpaRedirectResponse',
  ClientRedirect = 'ClientRedirect',
  ResetSession = 'ResetSession',
  AdditionalAction = 'AdditionalAction',
  FollowUrl = 'FollowUrl',
}

export default SubmitResponseType;
